function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("g", {
  fill: "none",
  fillRule: "evenodd"
}, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
  fill: "#299D74",
  stroke: "#F6FAFB",
  d: "M0 0H17V17H0z",
  transform: "translate(-190.000000, -268.000000) translate(191.000000, 269.000000)"
}), /*#__PURE__*/React.createElement("path", {
  fill: "#F8F9FB",
  d: "M12.492 3L7.169 9.988 4.36 7.068 3 8.497 7.347 13 14 4.242z",
  transform: "translate(-190.000000, -268.000000) translate(191.000000, 269.000000)"
}))));

function SvgCheckboxChecked({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref);
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckboxChecked);
export default __webpack_public_path__ + "static/media/checkbox-checked.780961f8.svg";
export { ForwardRef as ReactComponent };